var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.toTop()}}},[_c('span',{staticClass:"icon-nav_chevron_up"})])}
var staticRenderFns = []

export { render, staticRenderFns }